import {Authenticator} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import "./styles.scss";

const formFields = {
    signUp: {
      email: {
        order: 1
      },
      username: {
        order: 2
      },
      password: {
        order: 3
      },
      confirm_password: {
        order: 4
      },
      name: {
        order: 5,
        labelHidden: false,
        placeholder: 'Name',
        isRequired: false,
      }
   },
}

const Login = () => {
    return(
        <div className="auth">
        <Authenticator formFields={formFields} signUpAttributes={['email', 'name']}>
            {({ signOut, user }) => (
                <main>
                <h1>Hello {user.username}</h1>
                <button onClick={signOut}>Sign out</button>
                </main>
      )}

    </Authenticator>
    </div>
    )
}
            
export default Login;